import { useEffect, useState } from 'react';
import { Input } from '@bitrise/bitkit';

const INVALID_BRANCH_NAME_PATTERN = /(^(\.|\/))|((\.lock|\/)$)|[\^:~*\\\s\p{Cc}]|\.{2}|\/{2}|\/\.|@\{|\.lock\//iu;
export const validateBranchName = (rawValue: string, isBranchRequired: boolean | undefined) => {
  if (isBranchRequired && rawValue.length === 0) {
    return false;
  }
  return !INVALID_BRANCH_NAME_PATTERN.test(rawValue);
};

interface BranchManualInputProps {
  helperText?: string;
  infoTooltipLabel?: string;
  isLoading?: boolean;
  isRequired?: boolean;
  label: string;
  onChange: (newvalue: string, isValid: boolean) => void;
  value?: string;
}

export const BranchManualInput = ({
  helperText,
  infoTooltipLabel,
  isLoading,
  isRequired,
  label,
  onChange,
  value,
}: BranchManualInputProps) => {
  const [isError, setIsError] = useState(false);

  const handleChange = (branchName: string, isBranchRequired?: boolean) => {
    const isBranchValid = validateBranchName(branchName, isBranchRequired);
    setIsError(!isBranchValid);
    onChange(branchName, isBranchValid);
  };

  useEffect(() => {
    if (!isRequired && !value) {
      setIsError(false);
    }
  }, [isRequired, value]);

  return (
    <Input
      placeholder={isLoading ? '' : 'Enter a branch'}
      onChange={({ target }) => handleChange(target.value.trim(), isRequired)}
      value={value || ''}
      errorText={isError ? 'Enter a valid branch name.' : ''}
      helperText={helperText}
      isRequired={isRequired}
      label={label}
      infoTooltipLabel={infoTooltipLabel}
      flex="1"
      autoFocus
    />
  );
};
